












































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';

import RollMixin from '@/mixins/RollMixin';

@Component({})
export default class AccordionItem extends Mixins(RollMixin) {
	@Prop({required: true}) readonly index: number;
	@Prop({required: true}) readonly name: string;
	@Prop({required: false, default: false}) readonly canToggle: boolean;
	@Prop({required: true}) readonly title: string;
	@Prop({required: true}) readonly content: string;
	@Prop({required: true}) readonly cards: any;
	@Prop({required: false, default: ''}) readonly animatedCards: string;

	initialHeight: number = 0;

	isMounted: boolean = false;
	isOpened: boolean = false;
	openTL: any;
	closeTL: any;

	get activeAccordionItem(): number {
		return this.$store.state.help.activeItem;
	}

	get canBeToggled(): boolean {
		return this.canToggle;
	}

	@Watch('canBeToggled')
	async onItemChanged(newValue: number) {
		if (!newValue) {
			return;
		}

		if (this.index === 0) {
			await this.toggle();
		}
	}

	async mounted() {
		if (typeof window === 'undefined') {
			return;
		}

		this.initialHeight = (this.$el as HTMLElement).getBoundingClientRect().height - 40;

		this.$nextTick(() => {
			this.isMounted = true;
		});


		if (!this.$route.meta.faq) {
			return;
		}

		if (this.index === this.activeAccordionItem) {
			await this.toggle();
		}

	}

	async toggle(value?: boolean, manual: boolean = false): Promise<void> {
		this.isOpened = typeof value === 'boolean' ? value : !this.isOpened;

		if (this.isOpened) {

			if (manual) {
				this.$root.$emit('canScrollToTop', {name: this.name});
			}

			if (this.$route.meta.faq) {
				if (this.$route.query.section) {
					delete this.$route.query.section;
				}

				await this.$router.replace({
					query: {
						section: `${this.index}`
					}
				});
			}

			(this.$parent as any).toggleAllExcept(this.index);

			if (typeof this.cards === 'undefined') {
				return;
			}

			this.$store.dispatch('updateAnimationCardsName', {
				key: this.animatedCards,
				state: this.cards
			});

		}
	}

}
